import { combineReducers } from 'redux-immutable'
import { Map, Set } from 'immutable';
import dataReducer from './dataReducer'
import { dummyReducerFacory } from '../helpers';
import requestStatus from '../../constants/requestStatus';


const INIT_STATE = Map();

const pagesReducer = dummyReducerFacory(Map({
    status: requestStatus.INITIALIZED,
    items: Map(),
    order: null,
    deletedItems: Set(),
    error: Map()
}))

const servicePagesReducer = dummyReducerFacory(Map({
    status: requestStatus.INITIALIZED,
    items: Map(),
    order: null,
    deletedItems: Set(),
    error: Map()
}))

const menuItemsReducer = dummyReducerFacory(Map({
    status: requestStatus.INITIALIZED,
    items: Map(),
    order: null,
    deletedItems: Set(),
    error: Map()
}))

const combinedReducer = combineReducers({
    pages: pagesReducer,
    servicePages: servicePagesReducer,
    menuItems: menuItemsReducer,
    data: dataReducer
});


const wpLocalDataReducer = (state  = INIT_STATE, action) => combinedReducer(state, action)

export default wpLocalDataReducer;